import React, { MouseEvent, useState } from "react";

import { Grid, IconButton, List, Menu } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { FiFilter } from "react-icons/fi";

import Button, { Color } from "../../../../../components/Form/Button";
import Input from "../../../../../components/Form/Input";
import useStyles from "./styles";

interface Props {
  handleSearch: (search: string) => void;
}

const SearchFilter = ({ handleSearch }: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [inputSearch, setInputSearch] = useState<string>("");

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Input
          value={inputSearch}
          onChange={(event) => setInputSearch(event.target.value)}
          data-cy="reportsMainScreenInput"
          placeholder={translate("search")}
          rightIcon={
            <IconButton
              className={classes.iconSearchButton}
              onClick={() => handleSearch(inputSearch)}
              data-cy="reportsMainScreenSearchIcon"
            >
              <SearchIcon />
            </IconButton>
          }
          onKeyDown={(event) => {
            if (event.key && event.key.toLowerCase().trim() === "enter") {
              handleSearch(inputSearch);
            }
          }}
        />
      </Grid>
      {false && (
        <Grid item xs={2}>
          <Button
            startIcon={<FiFilter size={15} color="#FFFFFF" />}
            onClick={handleClick}
            className={classes.filterButton}
            style={{
              backgroundColor: anchorEl ? "#03569E" : undefined,
            }}
          >
            <span className={classes.textButton}>{translate("filters")}</span>
          </Button>
          <Menu
            data-cy="menu-filter-by"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleClose()}
            disableRestoreFocus
            PaperProps={{
              className: classes.menu,
            }}
            MenuListProps={{
              style: {
                padding: 0,
              },
            }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{ horizontal: "center", vertical: "top" }}
          >
            <div data-cy="container">
              <div data-cy="header" className={classes.menuHeader}>
                <span data-cy="title" className={classes.textHeader}>
                  {translate("filters")}
                </span>
                <Button data-cy="button-save" customColor={Color.SECONDARY}>
                  {translate("go")}
                </Button>
              </div>
              <List
                component="nav"
                data-cy="list-categories"
                className={classes.list}
                aria-labelledby="nested-list-subheader"
              ></List>
            </div>
          </Menu>
        </Grid>
      )}
    </Grid>
  );
};

export default SearchFilter;
